$(document).ready(function () {

  
  var LinkGet = (window.location.pathname);
  
  $(".custom-brand .col-sm-12 > div").each(function(){
  var getLink = $(this).children(".menu-item-mega").children("a").attr("href");
    
       if(LinkGet.indexOf(getLink) != -1){
    console.log(getLink);
      $(".filter-group-brands").hide();
      return false;
      
    }
  })
  
  
  $('.search-i-ic').click(function(){
    console.log('search click');
    $(this).parent('.sml-full-width-search').toggleClass('sml-full-width-search-open');
  });
  
  
  
 var GetSKU = $(".product-sku").html();
  var Length = $(".single-option-selector-product-template").length;
  if(Length >0 ){
    if(GetSKU.indexOf("-") != -1){
    GetSKU = GetSKU.split("-");
      var arrayLenth = (GetSKU.length);
      if(arrayLenth = 3){
      $(".product-sku").html(GetSKU[0]+"-"+GetSKU[1]);
      }
      else{
      $(".product-sku").html(GetSKU[0]);
      }
    }
  }
  var locationGet = window.location.href;
  if(locationGet == "https://a.plus/account" ){
    var wishlist_tab = getCookie("wishlist_tab");
    if(wishlist_tab ==  1){
    $(".WishlistClick a").trigger( "click" );
      $.cookie("wishlist_tab", null, { path: '/' });
    }
  
  }
    if(locationGet == "https://a.plus/account" ){
    var Mobwishlist_tab = getCookie("Mobwishlist_tab");
    if(Mobwishlist_tab ==  1){
     
    $(".WishlistClick a").trigger( "click" );
        $(".account-tab-drop-links .account-tab-drop-link-val span").html("wishlist");
       
      $.cookie("Mobwishlist_tab", null, { path: '/' });
    }
  
  }
// function setCookie(cname, cvalue, exdays) {
//       var d = new Date();
//       d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
//       var expires = "expires="+d.toUTCString();
//       document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
//     }

//     function getCookie(cname) {
//       var name = cname + "=";
//       var ca = document.cookie.split(';');
//       for(var i = 0; i < ca.length; i++) {
//         var c = ca[i];
//         while (c.charAt(0) == ' ') {
//           c = c.substring(1);
//         }
//         if (c.indexOf(name) == 0) {
//           return c.substring(name.length, c.length);
//         }
//       }
//       return "";
//     }
  $(".MobSetForCooki").click(function(){
		 setCookie("Mobwishlist_tab", 1, 365);
    })
	 $(".SetForCooki").click(function(){
		 setCookie("wishlist_tab", 1, 365);
    })
var len = $(".single-option-selector-product-template").length;
 
$(".single-option-selector-product-template").prepend('<option value="">select size</option>').val('').trigger('change');
 if(len == 1)
 {
   
  $(".shopify-payment-button").addClass( "disabled " );
        
    $("#AddToCart-product-template").attr('disabled', 'disabled');
 }
  var selectedVal = $(".single-option-selector-product-template option:selected").val();
 
  if(selectedVal == "")
  {
   $(".shopify-payment-button").addClass( "disabled " );
   
    $("#AddToCart-product-template").prop( "disabled", true );
       
  }
  $('.single-option-selector-product-template').on('change', function() {
    var newselectedVal = $(this).val();
  if(newselectedVal == "")
  {
 $(".shopify-payment-button").addClass( "disabled " );


  }
    else{
    $(".shopify-payment-button").removeClass( "disabled " );
   
      
    }
});
//    $(".custom-cancel").click(function(){
//    var dataId =   $(this).attr("data-id");
//    var dataemail = $(this).attr("data-mail"); 
//      $("#ContactFormId").val(dataId);
//      $(".CustomSubmitContact").trigger("click");
//    })
   $(".toggle-custom-filter span").click(function(e){
     e.preventDefault();
   $(this).parents(".toggle-custom-filter").next(".both-filters").toggleClass("active-filters-dropdown");
     $(this).toggleClass("active-filters-toggle");
     $(this).parents(".toggle-custom-filter").next(".both-filters").slideToggle();
     var HtGet = $(".filter-menu").height();
     HtGet = HtGet-10;
     if ($(window).width() > 767) {
   $(".filter-group").css("min-height",HtGet);
     }
   })
   
//    $('.mobile-select-tabs').on('change', function() {
//   var onChange = this.value;
//      $(".rt-unero-MyAccount-navigation-link").each(function(){
//        var tabcontent = $(this).children("a").html();
//        if(tabcontent==onChange){
//        $(this).children("a").trigger("click");
//        }
//      })
// });
   $(".account-tab-drop-link-val").click(function(){
    $(this).toggleClass("active-icon-sign");
   $(this).next(".account-tab-drop-link-list").toggleClass("active-tab-link");
   })
   $('body').on('click', '.account-tab-drop-link-list.active-tab-link li', function() {
  
    var onChange = $(this).html();
     $(".account-tab-drop-link-val span").html(onChange);
     $(".rt-unero-MyAccount-navigation-link").each(function(){
       var tabcontent = $(this).children("a").html();
       if(tabcontent==onChange){
       $(this).children("a").trigger("click");
       }
     })
      $(".account-tab-drop-link-val.active-icon-sign").removeClass("active-icon-sign");
     $(this).parents(".account-tab-drop-link-list").removeClass("active-tab-link");
   })
   $(".mob-search-icon").click(function(){
   $(".outer-down-full").slideToggle();
   })
   $('.more-brand-cr-block-main').slick({
  infinite: true,
  slidesToShow: 4,
     dots: true,
  slidesToScroll: 4
});
});